import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import get from "lodash/get"
import { READ_PLAN_EVENTS_LIST } from "../actions/types"
import {
  readPlanEventListSuccess,
  readPlanEventListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

// read list saga
function* requestRead(action) {
  const {
    config: { uuid, params },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/plans/${uuid}/events`,
      method: `get`,
      params,
    })
    const responseData = get(response, `data`)
    const totalCount = get(response, `headers.total-count`)
    yield put(
      readPlanEventListSuccess(action, { data: responseData, totalCount }),
    )
  } catch (error) {
    yield put(readPlanEventListError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(READ_PLAN_EVENTS_LIST, requestRead)
}
